// extracted by mini-css-extract-plugin
module.exports = {"view":"_13227","image":"_14445","full":"_19559","video":"_18720","button":"_18957","arrow":"_5587"};